module.exports = __webpack_public_path__ + "img/er.ae08238c.svg";